// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ivu-table .table-invalid-row td{color:#777!important}.ivu-table .ivu-table-row-hover td{color:#aaa!important}", ""]);
// Exports
module.exports = exports;
